<div class="audit-log">
  <div class="audit-log__header">
    <p>{{'AUDIT_LOG.DESCRIPTION' | translate}}</p>
  </div>

  <div class="accordion" [ngClass]="{'border-collapsed': isCollapsed, 'border-expanded': !isCollapsed}">
    <div class="accordion__header" (click)="collapse()">
      <div class="accordion__header-title">
        <div class="accordion__header-title__label">
          <bzg-icon nameIcon="icon-filters"></bzg-icon>
          <h2>{{ 'AUDIT_LOG.FILTERS' | translate}}</h2>
        </div>
        <svg class="accordion__header-title__icon" [ngClass]="{'accordion__rotate-icon': !isCollapsed}">
          <use href="#icon-arrow-down-bold"></use>
        </svg>
      </div>
    </div>

    <div *ngIf="!isCollapsed" class="accordion__content">
      <div class="accordion-separator"></div>
      <div class="accordion__filter">
        <div class="accordion__filter-element">
          <span class="accordion__filter-label">{{'AUDIT_LOG.CATEGORY' | translate}} *
          </span>
          <bzg-select [placeholder]="'AUDIT_LOG.CATEGORY' | translate" [(value)]="selectedCategory"
            (valueChange)="changeCategory($event)">
            <bzg-option *ngFor="let category of categories" [value]="category">{{("AUDIT_LOG.CATEGORY_" + category) | uppercase | translate}}</bzg-option>
          </bzg-select>
        </div>
        <div class="accordion__filter-element">
          <span class="accordion__filter-label">{{'AUDIT_LOG.SUBCATEGORY' | translate}}
          </span>
          <bzg-select [placeholder]="'AUDIT_LOG.SUBCATEGORY' | translate" [(value)]="selectedSubcategory"
            (valueChange)="changeSubcategory($event)" [disabled]="!selectedCategory">
            <bzg-option [value]="''">{{'AUDIT_LOG.ALL' | translate}}</bzg-option>
            <bzg-option *ngFor="let subcategory of subcategories" [value]="subcategory">{{("AUDIT_LOG.SUBCATEGORY_" + subcategory) | uppercase | translate}}</bzg-option>
          </bzg-select>
        </div>
        <div class="accordion__filter-element">
          <span class="accordion__filter-label">{{'AUDIT_LOG.ACTION' | translate}}
          </span>
          <bzg-select [placeholder]="'AUDIT_LOG.ACTION' | translate" [(value)]="selectedAction"
            [disabled]="!selectedSubcategory">
            <bzg-option [value]="''">{{'AUDIT_LOG.ALL' | translate}}</bzg-option>
            <bzg-option *ngFor="let action of actions" [value]="action">{{("AUDIT_LOG.ACTION_" + action) | uppercase | translate}}</bzg-option>
          </bzg-select>
        </div>
        <div class="accordion__filter-element accordion__filter-element-input">
          <span class="accordion__filter-label">{{'AUDIT_LOG.USERNAME' | translate}}
          </span>
          <bzg-select [placeholder]="'AUDIT_LOG.USERNAME_PLACEHOLDER' | translate" [(value)]="selectedUsername" [title]="selectedUsername">
            <bzg-option *ngFor="let user of users" [value]="user" [title]="user">{{user}}</bzg-option>
          </bzg-select>
        </div>
        <div class="accordion__filter-date">
          <div>
            <div class="accordion__filter-element-date">{{'AUDIT_LOG.MESSAGE_DATE' | translate}}</div>
            <bz-date-filter-time [isDisabled]="false" [dateMin]="dateMin" [dateMax]="dateMax"
              [showMessage]="showMessage" (onBtnFilterClick)="changeDatesLog($event)" [isEventChange]="true">
            </bz-date-filter-time>
          </div>
        </div>
        <div class="accordion__filter-btn" [ngClass]="{ 'accordion__filter-btn-end': !disabledButton(), 'accordion__filter-btn-space': disabledButton()}">
          <div class="accordion__filter-element-date-error" *ngIf="disabledButton()">* {{'AUDIT_LOG.INITIAL_DATE_GREATER_THAN_FINAL' | translate}}</div>
          <div class="accordion__filter-btn-space">
            <bzg-button-secondary  (click)="cleanFilters()">{{'AUDIT_LOG.CLEAN_FILTERS' | translate}}</bzg-button-secondary>
            <bzg-button-primary [disabled]="disabledButton() || selectedCategory === ''" (click)="getFilesNames(false)">{{'AUDIT_LOG.APPLY_FILTERS' | translate}}</bzg-button-primary>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="audit-log__content">

    <div class="audit-log__content-records" [ngClass]="setClass()">
      <bzg-table style="width: 100%" *ngIf="logs && logs.length > 0" [(model)]="logs" [showPaginator]="false"
        [cellSpacingMode]="'compact'" pageSize="10" [allowOrderColumn]="true" [orderDirection]="orderDirection" [fixedHeader]="true"
        [orderColumn]="orderColumnField" [responsive]="true" [showSingleLineCell]="true" [showSingleLineHeader]="true" [showSelectionColumn]="false">
  
        <ng-template bzgTableColumn width="20%" id="Timestamp"  [allowOrder]="true" title="{{'AUDIT_LOG.DATE' | translate}}" let-dataItem="dataItem">
          <p title="{{ dataItem.Timestamp | userTimezoneFormat:1 }}" class="table__labels">{{ dataItem.Timestamp | userTimezoneFormat:1 }}</p>
        </ng-template>
  
        <ng-template bzgTableColumn width="20%" id="UserName" [allowOrder]="true" title="{{'AUDIT_LOG.USERNAME' | translate}}" let-dataItem="dataItem">
          <p title="{{ dataItem.UserName}}" class="table__labels">{{ dataItem.UserName}}</p>
        </ng-template>

        <ng-template bzgTableColumn width="20%" id="Action" [allowOrder]="true" title="{{'AUDIT_LOG.ACTION' | translate}}" let-dataItem="dataItem">
          <p title="{{ ('AUDIT_LOG.ACTION_' + dataItem.Action) | uppercase | translate }}" class="table__labels">{{("AUDIT_LOG.ACTION_" + dataItem.Action) | uppercase | translate}}</p>
        </ng-template>
  
        <ng-template bzgTableColumn width="40%" id="Info" [allowOrder]="true" title="{{'AUDIT_LOG.INFORMATION' | translate}}" let-dataItem="dataItem">
          <p title="{{ dataItem.Info}}" class="table__labels">{{ dataItem.Info}}</p>
        </ng-template>

        <ng-template bzgTableColumnDetail let-dataItem="dataItem" visibleCondition="'true'">
          <div class="audit-log__content-records-detail">
            <!-- <div class="audit-log__content-records-detail-element">
              <span class="audit-log__content-records-detail-element-label">{{'AUDIT_LOG.USERNAME' | translate}}:</span>
              <span class="audit-log__content-records-detail-element-value">{{dataItem.UserName}}</span>
            </div>
            <div class="audit-log__content-records-detail-element">
              <span class="audit-log__content-records-detail-element-label">{{'AUDIT_LOG.DATE' | translate}}:</span>
              <span class="audit-log__content-records-detail-element-value">{{dataItem.Timestamp | userTimezoneFormat:1}}</span>
            </div> -->
            <div class="audit-log__content-records-detail-element">
              <span class="audit-log__content-records-detail-element-label">{{'AUDIT_LOG.CATEGORY' | translate}}:</span>
              <span class="audit-log__content-records-detail-element-value">{{ ('AUDIT_LOG.CATEGORY_' + dataItem.Category) | uppercase | translate }}</span>
            </div>
            <div class="audit-log__content-records-detail-element">
              <span class="audit-log__content-records-detail-element-label">{{'AUDIT_LOG.SUBCATEGORY' | translate}}:</span>
              <span class="audit-log__content-records-detail-element-value">{{ ('AUDIT_LOG.SUBCATEGORY_' + dataItem.SubCategory) | uppercase | translate }}</span>
            </div>
            <div class="audit-log__content-records-detail-element">
              <span class="audit-log__content-records-detail-element-label">{{'AUDIT_LOG.ACTION' | translate}}:</span>
              <span class="audit-log__content-records-detail-element-value">{{ ('AUDIT_LOG.ACTION_' + dataItem.Action) | uppercase | translate }}</span>
            </div>
            <div class="audit-log__content-records-detail-element">
              <span class="audit-log__content-records-detail-element-label">{{'AUDIT_LOG.INFORMATION' | translate}}:</span>
              <span class="audit-log__content-records-detail-element-value">{{dataItem.Info}}</span>
            </div>
          </div>
        </ng-template>
      </bzg-table>

      <div (click)="getFilesNames(true)" *ngIf="showMoreMessage" class="audit-log__content-records-more">
        {{'AUDIT_LOG.LOAD_MORE' | translate}}
      </div>
    </div>

    <div class="audit-log__content-no-records" *ngIf="logs.length == 0">
      <img class="trace-viewer__img" src="assets/img/no_found.png">
      <span>{{ 'AUDIT_LOG.NO_RECORDS' | translate}}</span>
    </div>
  </div>
</div>